export default "__VITE_ASSET__DKSMD0N$__"